// prettier-ignore
import { ProctorBucketAllocation, buildProctorBucketAllocation } from '../../../shared/proctor/ProctorBucketAllocation';
import { ProctorAllocation } from '../../../shared/native-modules/types/JSTProctorBridge';
import { applyProctorOverride } from '../../../shared/proctor/applyProctorOverride';
import { createContext, useCallback, useContext } from 'react';
import { getProctorAllocations } from '../../../shared/native-modules/tare/getProctorAllocations';
import { HomepageProctorSpecification, HomepageProctorSpecifications } from './HomepageProctorSpecifications';
import { usePromise } from '../../../shared/util/usePromise';

const HomepageProctorContext = createContext<Record<string, ProctorAllocation>>({});

export function useLoadHomepageProctorAllocations() {
    const loadAllocations = useCallback(() => getProctorAllocations(HomepageProctorSpecifications), []);
    return usePromise(loadAllocations);
}

export function useAllHomepageProctorAllocations(): Record<string, ProctorAllocation> {
    return useContext(HomepageProctorContext);
}

export function useHomepageProctorAllocation<Specification extends HomepageProctorSpecification>(
    test: Specification,
): ProctorBucketAllocation<Specification> {
    const allocations = useContext(HomepageProctorContext);
    const allocation = allocations[test.name];
    return buildProctorBucketAllocation(test, allocation);
}

/**
 * Provides a React context for the proctor allocations used in this React Native provider
 */
export function HomepageProctorProvider({
    children,
    allocations,
    override,
}: {
    children: React.ReactNode;
    allocations: Record<string, ProctorAllocation>;
    override?: Record<string, ProctorAllocation> | null | undefined;
}) {
    const mergedAllocations = applyProctorOverride(HomepageProctorSpecifications, allocations, override);
    return <HomepageProctorContext.Provider value={mergedAllocations}>{children}</HomepageProctorContext.Provider>;
}